<template>
  <aside class="wizard__rail">
    <div class="wizard__rail-head">
      <h4>שלבי יצירה</h4>
      <h3>לינקטון חדש</h3>
    </div>
    <button
      v-for="(s, i) in steps"
      :key="s.key"
      type="button"
      class="step"
      :class="{ 'is-active': current === i, 'is-done': completed.includes(i) && current !== i }"
      @click="$emit('jump', i)"
    >
      <span class="step__num">
        <LtIcon v-if="completed.includes(i) && current !== i" name="check" :size="14" />
        <template v-else>{{ i + 1 }}</template>
      </span>
      <span class="step__label">
        {{ s.label }}
        <small>{{ s.hint }}</small>
      </span>
    </button>
  </aside>
</template>

<script>
import LtIcon from './LtIcon.vue';

export default {
  name: 'StepperRail',
  components: { LtIcon },
  props: {
    steps: { type: Array, required: true },
    current: { type: Number, required: true },
    completed: { type: Array, default: () => [] },
  },
  emits: ['jump'],
};
</script>
